import { useGetDestinationCountriesRequest } from "@/api/useGetDestinationCountriesRequest";
import { SelectOptions } from "../select-options";

export default function SelectDestinationCountryFlow({
  onSelect,
}: {
  onSelect: (selectedValue) => void;
}) {
  const { data } = useGetDestinationCountriesRequest();

  const destinationCountries = data?.data?.data
    ? data?.data?.data?.map((country) => {
        return {
          id: country.id,
          mainText: country.country,
          secondaryText: country.destination_country,
        };
      })
    : [];
  return (
    <SelectOptions
      options={destinationCountries}
      onSelect={onSelect}
      hideSearch
    />
  );
}
